// Redux
import { applyMiddleware, createStore, combineReducers, compose } from "redux";
import ReduxThunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import localforage from "localforage";

// import rootReducer,
import {
  authReducer,
  userReducer,
  callsReducer,
  operatorsReducer,
  companyReducer,
  analyticsReducer,
  financialInsightsReducer,
  financialDetailReducer,
  algoliaReducer,
  listsReducer,
  debriefReducer,
} from "./reducers";

const authPersistConfig = {
  key: "auth",
  storage: localforage,
  blacklist: [],
};

const userPersistConfig = {
  key: "user",
  storage: localforage,
  blacklist: [],
};

const callsPersistConfig = {
  key: "calls",
  storage: localforage,
  blacklist: [],
};

const listsPersistConfig = {
  key: "lists",
  storage: localforage,
  blacklist: [],
};

const compnayPersistConfig = {
  key: "company",
  storage: localforage,
  blacklist: [],
};

const operatorsPersistConfig = {
  key: "operators",
  storage: localforage,
  blacklist: [],
};

const analyticsPersistConfig = {
  key: "analytics",
  storage: localforage,
  blacklist: [],
};

const financialInsightsPersistConfig = {
  key: "financial_insights",
  storage: localforage,
  blacklist: [],
};

const financialDetailPersistConfig = {
  key: "financial_detail",
  storage: localforage,
  blacklist: [],
};

const algoliaPersistConfig = {
  key: "algolia",
  storage: localforage,
  blacklist: [],
};

const debriefPersistConfig = {
  key: "debrief",
  storage: localforage,
  blacklist: [],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  user: persistReducer(userPersistConfig, userReducer),
  calls: persistReducer(callsPersistConfig, callsReducer),
  lists: persistReducer(listsPersistConfig, listsReducer),
  company: persistReducer(compnayPersistConfig, companyReducer),
  operators: persistReducer(operatorsPersistConfig, operatorsReducer),
  analytics: persistReducer(analyticsPersistConfig, analyticsReducer),
  financial_insights: persistReducer(financialInsightsPersistConfig, financialInsightsReducer),
  financial_detail: persistReducer(financialDetailPersistConfig, financialDetailReducer),
  algolia: persistReducer(algoliaPersistConfig, algoliaReducer),
  debrief: persistReducer(debriefPersistConfig, debriefReducer),
});

// Middleware
const middleware = applyMiddleware(ReduxThunk);

// const persistedReducer = persistReducer(persistConfig, rootReducer2);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// export const store = createStore(persistedReducer, middleware());
export const store = createStore(rootReducer, composeEnhancers(middleware));

export const persistor = persistStore(store);
